import React, { useEffect } from "react";
import Footer from "../components/reusable/footer";
import AppHeader from "../components/reusable/header";
import HomeComponent from "../components/homeComps/homeComponents";

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
       
       
        <HomeComponent></HomeComponent>

       
    

  );
};

export default HomePage;
